(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[3213],{

/***/ 3011:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _styles_pstlandingpage_module_scss__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(42547);
/* harmony import */ var _styles_pstlandingpage_module_scss__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(_styles_pstlandingpage_module_scss__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var react_bootstrap_Container__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(10682);
/* harmony import */ var react_bootstrap_Row__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(34051);
/* harmony import */ var react_bootstrap_Col__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(31555);
/* harmony import */ var slick_carousel_slick_slick_css__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(98322);
/* harmony import */ var slick_carousel_slick_slick_css__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(slick_carousel_slick_slick_css__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var slick_carousel_slick_slick_theme_css__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(98745);
/* harmony import */ var slick_carousel_slick_slick_theme_css__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(slick_carousel_slick_slick_theme_css__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var react_bootstrap_Accordion__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(54076);
/* harmony import */ var _LazyReveal__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(70710);










const FaqComponent = (props)=>{
    const { 0: isViewMore , 1: setIsViewMore  } = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false);
    const { 0: showCardDetail , 1: setShowCardDetail  } = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(null);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_LazyReveal__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
        className: (_styles_pstlandingpage_module_scss__WEBPACK_IMPORTED_MODULE_5___default().faqComponent),
        style: {
            backgroundColor: props.sectionBgColor || "#EFEFFA"
        },
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_bootstrap_Container__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_bootstrap_Row__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            className: (_styles_pstlandingpage_module_scss__WEBPACK_IMPORTED_MODULE_5___default().heading),
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h2", {
                                    className: "text-center",
                                    children: props.title
                                }),
                                props.description ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h4", {
                                    children: props.description
                                }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h4", {
                                            children: props.subTitle1
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h4", {
                                            children: props.subTitle2
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h3", {
                                            children: props.subTitle3
                                        })
                                    ]
                                })
                            ]
                        })
                    })
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_bootstrap_Container__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_bootstrap_Row__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
                            className: (_styles_pstlandingpage_module_scss__WEBPACK_IMPORTED_MODULE_5___default().content),
                            children: props.faqPoints?.length > 0 && props.faqPoints.map((faqsdata, index)=>{
                                const condition = !isViewMore ? index < 5 : index >= 0;
                                const key = index.toString();
                                return condition && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_bootstrap_Col__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
                                    xl: 8,
                                    lg: 8,
                                    md: 8,
                                    sm: 8,
                                    xs: 8,
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_bootstrap_Accordion__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, {
                                        activeKey: showCardDetail,
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_bootstrap_Accordion__WEBPACK_IMPORTED_MODULE_9__/* ["default"].Item */ .Z.Item, {
                                            className: (_styles_pstlandingpage_module_scss__WEBPACK_IMPORTED_MODULE_5___default().stuAccordion),
                                            eventKey: key,
                                            children: [
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_bootstrap_Accordion__WEBPACK_IMPORTED_MODULE_9__/* ["default"].Header */ .Z.Header, {
                                                    className: (_styles_pstlandingpage_module_scss__WEBPACK_IMPORTED_MODULE_5___default().accoHead),
                                                    onClick: ()=>{
                                                        if (showCardDetail === key) {
                                                            setShowCardDetail(null);
                                                        } else {
                                                            setShowCardDetail(key);
                                                        }
                                                    },
                                                    children: [
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("span", {
                                                            style: {
                                                                color: ` ${showCardDetail === key ? "#0c63e4" : "#201f22"}`
                                                            },
                                                            children: [
                                                                " ",
                                                                faqsdata.title
                                                            ]
                                                        }),
                                                        " "
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_bootstrap_Accordion__WEBPACK_IMPORTED_MODULE_9__/* ["default"].Body */ .Z.Body, {
                                                    className: (_styles_pstlandingpage_module_scss__WEBPACK_IMPORTED_MODULE_5___default().accorBody),
                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                        dangerouslySetInnerHTML: {
                                                            __html: faqsdata.description
                                                        }
                                                    })
                                                })
                                            ]
                                        })
                                    })
                                }, index);
                            })
                        }),
                        props.faqPoints?.length > 5 && !isViewMore && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_bootstrap_Row__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
                            className: "text-center",
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: "mt-4 mb-3",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                    id: "faq-component",
                                    onClick: ()=>{
                                        setIsViewMore(true);
                                    },
                                    className: (_styles_pstlandingpage_module_scss__WEBPACK_IMPORTED_MODULE_5___default().viewMore),
                                    children: "View More"
                                })
                            })
                        })
                    ]
                })
            ]
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (FaqComponent);


/***/ }),

/***/ 55689:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _styles_pstlandingpage_module_scss__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(42547);
/* harmony import */ var _styles_pstlandingpage_module_scss__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(_styles_pstlandingpage_module_scss__WEBPACK_IMPORTED_MODULE_10__);
/* harmony import */ var react_bootstrap_Row__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(34051);
/* harmony import */ var _CustomImage__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(45992);
/* harmony import */ var react_slick__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(46066);
/* harmony import */ var slick_carousel_slick_slick_css__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(98322);
/* harmony import */ var slick_carousel_slick_slick_css__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(slick_carousel_slick_slick_css__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var slick_carousel_slick_slick_theme_css__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(98745);
/* harmony import */ var slick_carousel_slick_slick_theme_css__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(slick_carousel_slick_slick_theme_css__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var react_lazy_load_image_component__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(72679);
/* harmony import */ var react_lazy_load_image_component__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(react_lazy_load_image_component__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var react_bootstrap__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(10682);
/* harmony import */ var _utils_constants__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(59830);
/* harmony import */ var _LazyMedia__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(37462);
/* harmony import */ var _LazyReveal__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(70710);













const VideoTestimonials = (props)=>{
    const sliderRef = (0,react__WEBPACK_IMPORTED_MODULE_1__.useRef)(null);
    const limitedTestimonials = props.testimonialVideos?.sort((firstVideoTestimonial, secondVideoTestimonial)=>secondVideoTestimonial.id - firstVideoTestimonial.id)?.slice(0, 15);
    const videosCount = props.testimonialVideos?.length || 0;
    const videosSlidersettings = {
        infinite: videosCount > 3,
        arrows: false,
        speed: _utils_constants__WEBPACK_IMPORTED_MODULE_7__/* .sliderSpeed.desktopSpeed */ .Y$.desktopSpeed,
        slidesToShow: 3,
        slidesToScroll: 3,
        rows: 1,
        slidesPerRow: 1,
        responsive: [
            {
                breakpoint: 1024,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 2,
                    arrows: false,
                    infinite: videosCount > 2,
                    autoplay: true
                }
            },
            {
                breakpoint: 600,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    dotsClass: (_styles_pstlandingpage_module_scss__WEBPACK_IMPORTED_MODULE_10___default().sliderDots),
                    infinite: videosCount > 1,
                    dots: true,
                    autoplay: true,
                    autoplaySpeed: _utils_constants__WEBPACK_IMPORTED_MODULE_7__/* .sliderSpeed.mobileAutoplaySpeed */ .Y$.mobileAutoplaySpeed
                }
            }
        ]
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_LazyReveal__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, {
        className: (_styles_pstlandingpage_module_scss__WEBPACK_IMPORTED_MODULE_10___default().achievements),
        style: {
            backgroundColor: props.sectionBgColor || "#ffffff",
            ...props?.parentContainerStyles ?? {}
        },
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_bootstrap__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z, {
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: (_styles_pstlandingpage_module_scss__WEBPACK_IMPORTED_MODULE_10___default().containerDiv),
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_bootstrap_Row__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z, {
                        className: (_styles_pstlandingpage_module_scss__WEBPACK_IMPORTED_MODULE_10___default().heading),
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h2", {
                                children: props.title
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                className: (_styles_pstlandingpage_module_scss__WEBPACK_IMPORTED_MODULE_10___default().description),
                                children: props.subTitle
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: (_styles_pstlandingpage_module_scss__WEBPACK_IMPORTED_MODULE_10___default().sliderContainer),
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_slick__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                                ...videosSlidersettings,
                                className: (_styles_pstlandingpage_module_scss__WEBPACK_IMPORTED_MODULE_10___default().slider),
                                ref: sliderRef,
                                children: limitedTestimonials?.length > 0 && limitedTestimonials?.map((content, index)=>{
                                    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                        className: (_styles_pstlandingpage_module_scss__WEBPACK_IMPORTED_MODULE_10___default().achievementsDiv),
                                        children: [
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                className: (_styles_pstlandingpage_module_scss__WEBPACK_IMPORTED_MODULE_10___default().icon),
                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("svg", {
                                                    width: "33",
                                                    height: "22",
                                                    viewBox: "0 0 33 22",
                                                    fill: "none",
                                                    xmlns: "http://www.w3.org/2000/svg",
                                                    children: [
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                                            fillRule: "evenodd",
                                                            clipRule: "evenodd",
                                                            d: "M0.0267741 14.2441C0.0232465 14.3384 0.0214669 14.4331 0.0214669 14.5283C0.0214665 18.6548 3.36666 22 7.49316 22C11.6197 22 14.9648 18.6548 14.9648 14.5283C14.9648 10.4018 11.6197 7.05662 7.49316 7.05662C6.73028 7.05662 5.99411 7.17095 5.30084 7.38341C6.8185 4.06918 11.3775 1.11242 13.5805 1.32304e-05C2.06855 2.26919 -0.255979 10.4465 0.0207498 14.2516L0.0267741 14.2441Z",
                                                            fill: "#226CF5"
                                                        }),
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                                            fillRule: "evenodd",
                                                            clipRule: "evenodd",
                                                            d: "M18.0492 14.2439C18.0457 14.3382 18.0439 14.4331 18.0439 14.5283C18.0439 18.6548 21.3891 22 25.5156 22C29.6421 22 32.9873 18.6548 32.9873 14.5283C32.9873 10.4018 29.6421 7.05662 25.5156 7.05662C24.7527 7.05662 24.0164 7.17097 23.3231 7.38347C24.8408 4.06924 29.3998 1.11247 31.6028 6.47288e-05C20.0908 2.26924 17.7663 10.4466 18.043 14.2516L18.0492 14.2439Z",
                                                            fill: "#226CF5"
                                                        })
                                                    ]
                                                })
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                className: (_styles_pstlandingpage_module_scss__WEBPACK_IMPORTED_MODULE_10___default().videoDiv),
                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_lazy_load_image_component__WEBPACK_IMPORTED_MODULE_6__.LazyLoadComponent, {
                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_LazyMedia__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
                                                        iframeClassName: (_styles_pstlandingpage_module_scss__WEBPACK_IMPORTED_MODULE_10___default().studVideo),
                                                        src: content.videoLink,
                                                        title: "YouTube video player",
                                                        allow: "accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                                                    })
                                                })
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                className: (_styles_pstlandingpage_module_scss__WEBPACK_IMPORTED_MODULE_10___default().content),
                                                children: [
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h4", {
                                                        children: content.name
                                                    }),
                                                    content?.designation ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                                        children: content.designation
                                                    }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                                        children: content.university
                                                    })
                                                ]
                                            })
                                        ]
                                    }, index);
                                })
                            }),
                            props.testimonialVideos?.length > 3 && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                className: (_styles_pstlandingpage_module_scss__WEBPACK_IMPORTED_MODULE_10___default().arrowsClass),
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                        className: (_styles_pstlandingpage_module_scss__WEBPACK_IMPORTED_MODULE_10___default().btcircle),
                                        onClick: ()=>sliderRef?.current?.slickPrev(),
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_CustomImage__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                                            src: "/new-images/left-arrow.svg",
                                            height: 17,
                                            width: 10,
                                            alt: "left-arrow"
                                        })
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                        className: (_styles_pstlandingpage_module_scss__WEBPACK_IMPORTED_MODULE_10___default().btcircle),
                                        onClick: ()=>sliderRef?.current?.slickNext(),
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_CustomImage__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                                            src: "/new-images/right-arrow.svg",
                                            height: 17,
                                            width: 10,
                                            alt: "right-arrow"
                                        })
                                    })
                                ]
                            })
                        ]
                    })
                ]
            })
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (VideoTestimonials);


/***/ }),

/***/ 32892:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _styles_studentsacheivements_module_scss__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(82080);
/* harmony import */ var _styles_studentsacheivements_module_scss__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(_styles_studentsacheivements_module_scss__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var react_slick__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(46066);
/* harmony import */ var slick_carousel_slick_slick_css__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(98322);
/* harmony import */ var slick_carousel_slick_slick_css__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(slick_carousel_slick_slick_css__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var slick_carousel_slick_slick_theme_css__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(98745);
/* harmony import */ var slick_carousel_slick_slick_theme_css__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(slick_carousel_slick_slick_theme_css__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var react_bootstrap_Card__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(78182);
/* harmony import */ var react_bootstrap_Container__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(10682);
/* harmony import */ var react_bootstrap_Row__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(34051);
/* harmony import */ var react_bootstrap_Col__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(31555);
/* harmony import */ var _CustomImage__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(45992);
/* harmony import */ var _utils_fetchUtil__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(40607);
/* harmony import */ var _utils_constants__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(59830);













const StudentsAcheivents = ({ customClass , slug  })=>{
    const sliderRef = (0,react__WEBPACK_IMPORTED_MODULE_1__.useRef)(null);
    const { 0: achievementData , 1: setAchievementData  } = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)({});
    const settings = {
        dotsClass: (_styles_studentsacheivements_module_scss__WEBPACK_IMPORTED_MODULE_7___default().sliderDots),
        dots: true,
        infinite: false,
        speed: _utils_constants__WEBPACK_IMPORTED_MODULE_6__/* .sliderSpeed.desktopSpeed */ .Y$.desktopSpeed,
        slidesToShow: 3,
        slidesToScroll: 3,
        arrows: false,
        responsive: [
            {
                breakpoint: 1024,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 2
                }
            },
            {
                breakpoint: 600,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 2,
                    dots: false,
                    speed: _utils_constants__WEBPACK_IMPORTED_MODULE_6__/* .sliderSpeed.mobileSpeed */ .Y$.mobileSpeed
                }
            },
            {
                breakpoint: 480,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    dots: false,
                    speed: _utils_constants__WEBPACK_IMPORTED_MODULE_6__/* .sliderSpeed.mobileSpeed */ .Y$.mobileSpeed
                }
            }
        ]
    };
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(()=>{
        (0,_utils_fetchUtil__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)(`${"https://cms-staging.studies-overseas.com"}/${slug}`, "GET", {}, "", false).then((res)=>setAchievementData(res));
    }, []);
    return achievementData?.length > 0 ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        id: "students-acheivements",
        className: (_styles_studentsacheivements_module_scss__WEBPACK_IMPORTED_MODULE_7___default().studentsAcheivement),
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_bootstrap_Container__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, {
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_bootstrap_Row__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z, {
                    className: "text-center",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h2", {
                            children: "Our Students Achievements"
                        })
                    })
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_bootstrap_Row__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z, {
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_bootstrap_Col__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z, {
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            className: (_styles_studentsacheivements_module_scss__WEBPACK_IMPORTED_MODULE_7___default().batchesSlider),
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_slick__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                                    ...settings,
                                    ref: sliderRef,
                                    className: (_styles_studentsacheivements_module_scss__WEBPACK_IMPORTED_MODULE_7___default().slider),
                                    children: achievementData.map((student)=>{
                                        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                            className: (_styles_studentsacheivements_module_scss__WEBPACK_IMPORTED_MODULE_7___default().sliderCardDiv),
                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_bootstrap_Card__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z, {
                                                className: (_styles_studentsacheivements_module_scss__WEBPACK_IMPORTED_MODULE_7___default().cardCust),
                                                style: customClass ? {
                                                    minHeight: "250px"
                                                } : {},
                                                children: [
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                        className: (_styles_studentsacheivements_module_scss__WEBPACK_IMPORTED_MODULE_7___default().studeImgDiv),
                                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_CustomImage__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                                                            src: student.studentImageUrl,
                                                            alt: student.studentImageAltTag,
                                                            layout: "responsive",
                                                            height: 160,
                                                            width: 160,
                                                            className: (_styles_studentsacheivements_module_scss__WEBPACK_IMPORTED_MODULE_7___default().imgFrame)
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_bootstrap_Card__WEBPACK_IMPORTED_MODULE_12__/* ["default"].Body */ .Z.Body, {
                                                        className: (_styles_studentsacheivements_module_scss__WEBPACK_IMPORTED_MODULE_7___default().cardBody),
                                                        children: [
                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_bootstrap_Card__WEBPACK_IMPORTED_MODULE_12__/* ["default"].Text */ .Z.Text, {
                                                                className: (_styles_studentsacheivements_module_scss__WEBPACK_IMPORTED_MODULE_7___default().textName),
                                                                children: student.name
                                                            }),
                                                            student.points?.length > 0 && student.points.map((point)=>{
                                                                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_bootstrap_Card__WEBPACK_IMPORTED_MODULE_12__/* ["default"].Text */ .Z.Text, {
                                                                    className: (_styles_studentsacheivements_module_scss__WEBPACK_IMPORTED_MODULE_7___default().subTitle),
                                                                    style: customClass ? {
                                                                        textAlign: "center"
                                                                    } : {},
                                                                    children: [
                                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("span", {
                                                                            children: [
                                                                                point.label,
                                                                                " :"
                                                                            ]
                                                                        }),
                                                                        " ",
                                                                        point.value
                                                                    ]
                                                                });
                                                            })
                                                        ]
                                                    })
                                                ]
                                            })
                                        });
                                    })
                                }),
                                achievementData?.length > 3 && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                    className: (_styles_studentsacheivements_module_scss__WEBPACK_IMPORTED_MODULE_7___default().arrowsClass),
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                            className: (_styles_studentsacheivements_module_scss__WEBPACK_IMPORTED_MODULE_7___default().btcircle),
                                            onClick: ()=>sliderRef?.current?.slickPrev(),
                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_CustomImage__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                                                src: "/new-images/left-arrow.svg",
                                                height: 17,
                                                width: 10,
                                                alt: "left-arrow"
                                            })
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                            className: (_styles_studentsacheivements_module_scss__WEBPACK_IMPORTED_MODULE_7___default().btcircle),
                                            onClick: ()=>sliderRef?.current?.slickNext(),
                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_CustomImage__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                                                src: "/new-images/right-arrow.svg",
                                                height: 17,
                                                width: 10,
                                                alt: "right-arrow"
                                            })
                                        })
                                    ]
                                })
                            ]
                        })
                    })
                })
            ]
        })
    }) : null;
};
/* harmony default export */ __webpack_exports__["Z"] = (StudentsAcheivents);


/***/ }),

/***/ 42547:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"banner":"pstlandingpage_banner__g_UPf","nav":"pstlandingpage_nav__QrKZh","navLogo":"pstlandingpage_navLogo__rYw7Z","maincontent":"pstlandingpage_maincontent__tcl1X","fairdetails":"pstlandingpage_fairdetails___3Awg","heading":"pstlandingpage_heading__CmSZI","ulli":"pstlandingpage_ulli__fqPBp","liItem":"pstlandingpage_liItem__kE_QJ","regBtn":"pstlandingpage_regBtn__SXSXv","reg":"pstlandingpage_reg__808jO","enq":"pstlandingpage_enq__YbXM2","btnReg":"pstlandingpage_btnReg__ifx_Y","bannerStudDiv":"pstlandingpage_bannerStudDiv__h0Iis","bg":"pstlandingpage_bg__EOIvU","WhyKc":"pstlandingpage_WhyKc__aTj1F","viewMore":"pstlandingpage_viewMore__57U7q","whyMb":"pstlandingpage_whyMb__E2tnD","bussiness":"pstlandingpage_bussiness__8M5jS","uni":"pstlandingpage_uni__iGGja","img":"pstlandingpage_img__zoQjU","logo":"pstlandingpage_logo__PhEVL","sliderdiv":"pstlandingpage_sliderdiv__WSqCW","capabilityBg":"pstlandingpage_capabilityBg__e8FfP","content":"pstlandingpage_content__Lr07i","subcontent":"pstlandingpage_subcontent__bduG9","imgRow":"pstlandingpage_imgRow__5PEei","steps":"pstlandingpage_steps__uo121","points":"pstlandingpage_points__Qc5ZJ","mainbox":"pstlandingpage_mainbox__2nHev","boximg":"pstlandingpage_boximg___iqhq","association":"pstlandingpage_association__KcsWN","custCard":"pstlandingpage_custCard__2dOTw","imgDiv":"pstlandingpage_imgDiv__zKq9h","cardBody":"pstlandingpage_cardBody__5VPch","mainDiv":"pstlandingpage_mainDiv__E_si7","div":"pstlandingpage_div__12NSx","footer":"pstlandingpage_footer__UMKA1","footerlogo":"pstlandingpage_footerlogo__r5ngN","activeClass":"pstlandingpage_activeClass__XLLQe","arrowsClass":"pstlandingpage_arrowsClass___Haw3","btcircle":"pstlandingpage_btcircle__Sy1vj","sliderDots":"pstlandingpage_sliderDots__f2brx","elanLoansComp":"pstlandingpage_elanLoansComp__Xu5qO","elanContent":"pstlandingpage_elanContent__a4FxP","elanSubheading":"pstlandingpage_elanSubheading__MZ9zo","slider":"pstlandingpage_slider__ux_j6","imageDiv":"pstlandingpage_imageDiv__zXYkn","countryName":"pstlandingpage_countryName__y5U_f","button":"pstlandingpage_button__Hj8FU","enquirebtn":"pstlandingpage_enquirebtn__HXtlR","achievements":"pstlandingpage_achievements__4uMWW","description":"pstlandingpage_description__9Po_q","containerDiv":"pstlandingpage_containerDiv__1iO_z","sliderContainer":"pstlandingpage_sliderContainer__BD5UY","achievementsDiv":"pstlandingpage_achievementsDiv__gDUMc","icon":"pstlandingpage_icon__6cN3s","studVideo":"pstlandingpage_studVideo__57n8X","videoDiv":"pstlandingpage_videoDiv__gcrFA","videos":"pstlandingpage_videos__mNRB3","faqComponent":"pstlandingpage_faqComponent__DG96z","box":"pstlandingpage_box__dSteF","stuAccordion":"pstlandingpage_stuAccordion__0Carb","accoHead":"pstlandingpage_accoHead__5gc_W","card":"pstlandingpage_card___j1YG","cardImgDiv":"pstlandingpage_cardImgDiv__ANALH","cardImg":"pstlandingpage_cardImg__n_32_","caption":"pstlandingpage_caption___TAdQ","caption2":"pstlandingpage_caption2__V6haF","localeButton":"pstlandingpage_localeButton__N8bhp","selectClass":"pstlandingpage_selectClass__l1KDY"};

/***/ }),

/***/ 82080:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"studentsAcheivement":"studentsacheivements_studentsAcheivement__FapVw","sliderCardDiv":"studentsacheivements_sliderCardDiv__BwUMY","sliderDots":"studentsacheivements_sliderDots__VvXhr","batchesSlider":"studentsacheivements_batchesSlider__Ekgf0","textName":"studentsacheivements_textName__V51tq","subTitle":"studentsacheivements_subTitle__hyhHb","smallText":"studentsacheivements_smallText__EANoc","cardCust":"studentsacheivements_cardCust__fvo7N","studeImgDiv":"studentsacheivements_studeImgDiv___74Rk","cardBody":"studentsacheivements_cardBody__T76YR","imgFrame":"studentsacheivements_imgFrame__VoQ7S","arrowsClass":"studentsacheivements_arrowsClass__Z6v8g","btcircle":"studentsacheivements_btcircle__SHwU9"};

/***/ }),

/***/ 54076:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ esm_Accordion; }
});

// EXTERNAL MODULE: ./node_modules/react-bootstrap/node_modules/classnames/index.js
var classnames = __webpack_require__(44036);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/uncontrollable/lib/esm/index.js + 4 modules
var esm = __webpack_require__(47150);
// EXTERNAL MODULE: ./node_modules/react-bootstrap/esm/ThemeProvider.js
var ThemeProvider = __webpack_require__(76792);
// EXTERNAL MODULE: ./node_modules/dom-helpers/esm/css.js + 5 modules
var css = __webpack_require__(91505);
// EXTERNAL MODULE: ./node_modules/react-transition-group/esm/Transition.js + 3 modules
var Transition = __webpack_require__(23594);
// EXTERNAL MODULE: ./node_modules/react-bootstrap/esm/transitionEndListener.js
var transitionEndListener = __webpack_require__(93825);
;// CONCATENATED MODULE: ./node_modules/react-bootstrap/esm/createChainedFunction.js
/**
 * Safe chained function
 *
 * Will only create a new function if needed,
 * otherwise will pass back existing functions or null.
 *
 * @param {function} functions to chain
 * @returns {function|null}
 */
function createChainedFunction(...funcs) {
  return funcs.filter(f => f != null).reduce((acc, f) => {
    if (typeof f !== 'function') {
      throw new Error('Invalid Argument Type, must only provide functions, undefined, or null.');
    }

    if (acc === null) return f;
    return function chainedFunction(...args) {
      // @ts-ignore
      acc.apply(this, args); // @ts-ignore

      f.apply(this, args);
    };
  }, null);
}

/* harmony default export */ var esm_createChainedFunction = (createChainedFunction);
// EXTERNAL MODULE: ./node_modules/react-bootstrap/esm/triggerBrowserReflow.js
var triggerBrowserReflow = __webpack_require__(34509);
// EXTERNAL MODULE: ./node_modules/react-bootstrap/esm/TransitionWrapper.js
var TransitionWrapper = __webpack_require__(9337);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./node_modules/react-bootstrap/esm/Collapse.js









const MARGINS = {
  height: ['marginTop', 'marginBottom'],
  width: ['marginLeft', 'marginRight']
};

function getDefaultDimensionValue(dimension, elem) {
  const offset = `offset${dimension[0].toUpperCase()}${dimension.slice(1)}`;
  const value = elem[offset];
  const margins = MARGINS[dimension];
  return value + // @ts-ignore
  parseInt((0,css/* default */.Z)(elem, margins[0]), 10) + // @ts-ignore
  parseInt((0,css/* default */.Z)(elem, margins[1]), 10);
}

const collapseStyles = {
  [Transition/* EXITED */.Wj]: 'collapse',
  [Transition/* EXITING */.Ix]: 'collapsing',
  [Transition/* ENTERING */.d0]: 'collapsing',
  [Transition/* ENTERED */.cn]: 'collapse show'
};
const defaultProps = {
  in: false,
  timeout: 300,
  mountOnEnter: false,
  unmountOnExit: false,
  appear: false,
  getDimensionValue: getDefaultDimensionValue
};
const Collapse = /*#__PURE__*/react.forwardRef(({
  onEnter,
  onEntering,
  onEntered,
  onExit,
  onExiting,
  className,
  children,
  dimension = 'height',
  getDimensionValue = getDefaultDimensionValue,
  ...props
}, ref) => {
  /* Compute dimension */
  const computedDimension = typeof dimension === 'function' ? dimension() : dimension;
  /* -- Expanding -- */

  const handleEnter = (0,react.useMemo)(() => esm_createChainedFunction(elem => {
    elem.style[computedDimension] = '0';
  }, onEnter), [computedDimension, onEnter]);
  const handleEntering = (0,react.useMemo)(() => esm_createChainedFunction(elem => {
    const scroll = `scroll${computedDimension[0].toUpperCase()}${computedDimension.slice(1)}`;
    elem.style[computedDimension] = `${elem[scroll]}px`;
  }, onEntering), [computedDimension, onEntering]);
  const handleEntered = (0,react.useMemo)(() => esm_createChainedFunction(elem => {
    elem.style[computedDimension] = null;
  }, onEntered), [computedDimension, onEntered]);
  /* -- Collapsing -- */

  const handleExit = (0,react.useMemo)(() => esm_createChainedFunction(elem => {
    elem.style[computedDimension] = `${getDimensionValue(computedDimension, elem)}px`;
    (0,triggerBrowserReflow/* default */.Z)(elem);
  }, onExit), [onExit, getDimensionValue, computedDimension]);
  const handleExiting = (0,react.useMemo)(() => esm_createChainedFunction(elem => {
    elem.style[computedDimension] = null;
  }, onExiting), [computedDimension, onExiting]);
  return /*#__PURE__*/(0,jsx_runtime.jsx)(TransitionWrapper/* default */.Z, {
    ref: ref,
    addEndListener: transitionEndListener/* default */.Z,
    ...props,
    "aria-expanded": props.role ? props.in : null,
    onEnter: handleEnter,
    onEntering: handleEntering,
    onEntered: handleEntered,
    onExit: handleExit,
    onExiting: handleExiting,
    childRef: children.ref,
    children: (state, innerProps) => /*#__PURE__*/react.cloneElement(children, { ...innerProps,
      className: classnames_default()(className, children.props.className, collapseStyles[state], computedDimension === 'width' && 'collapse-horizontal')
    })
  });
}); // @ts-ignore

// @ts-ignore
Collapse.defaultProps = defaultProps;
/* harmony default export */ var esm_Collapse = (Collapse);
;// CONCATENATED MODULE: ./node_modules/react-bootstrap/esm/AccordionContext.js

function isAccordionItemSelected(activeEventKey, eventKey) {
  return Array.isArray(activeEventKey) ? activeEventKey.includes(eventKey) : activeEventKey === eventKey;
}
const context = /*#__PURE__*/react.createContext({});
context.displayName = 'AccordionContext';
/* harmony default export */ var AccordionContext = (context);
;// CONCATENATED MODULE: ./node_modules/react-bootstrap/esm/AccordionCollapse.js







const AccordionCollapse = /*#__PURE__*/react.forwardRef(({
  as: Component = 'div',
  bsPrefix,
  className,
  children,
  eventKey,
  ...props
}, ref) => {
  const {
    activeEventKey
  } = (0,react.useContext)(AccordionContext);
  bsPrefix = (0,ThemeProvider/* useBootstrapPrefix */.vE)(bsPrefix, 'accordion-collapse');
  return /*#__PURE__*/(0,jsx_runtime.jsx)(esm_Collapse, {
    ref: ref,
    in: isAccordionItemSelected(activeEventKey, eventKey),
    ...props,
    className: classnames_default()(className, bsPrefix),
    children: /*#__PURE__*/(0,jsx_runtime.jsx)(Component, {
      children: react.Children.only(children)
    })
  });
});
AccordionCollapse.displayName = 'AccordionCollapse';
/* harmony default export */ var esm_AccordionCollapse = (AccordionCollapse);
;// CONCATENATED MODULE: ./node_modules/react-bootstrap/esm/AccordionItemContext.js

const AccordionItemContext_context = /*#__PURE__*/react.createContext({
  eventKey: ''
});
AccordionItemContext_context.displayName = 'AccordionItemContext';
/* harmony default export */ var AccordionItemContext = (AccordionItemContext_context);
;// CONCATENATED MODULE: ./node_modules/react-bootstrap/esm/AccordionBody.js







const AccordionBody = /*#__PURE__*/react.forwardRef(({
  // Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
  as: Component = 'div',
  bsPrefix,
  className,
  ...props
}, ref) => {
  bsPrefix = (0,ThemeProvider/* useBootstrapPrefix */.vE)(bsPrefix, 'accordion-body');
  const {
    eventKey
  } = (0,react.useContext)(AccordionItemContext);
  return /*#__PURE__*/(0,jsx_runtime.jsx)(esm_AccordionCollapse, {
    eventKey: eventKey,
    children: /*#__PURE__*/(0,jsx_runtime.jsx)(Component, {
      ref: ref,
      ...props,
      className: classnames_default()(className, bsPrefix)
    })
  });
});
AccordionBody.displayName = 'AccordionBody';
/* harmony default export */ var esm_AccordionBody = (AccordionBody);
;// CONCATENATED MODULE: ./node_modules/react-bootstrap/esm/AccordionButton.js







function useAccordionButton(eventKey, onClick) {
  const {
    activeEventKey,
    onSelect,
    alwaysOpen
  } = (0,react.useContext)(AccordionContext);
  return e => {
    /*
      Compare the event key in context with the given event key.
      If they are the same, then collapse the component.
    */
    let eventKeyPassed = eventKey === activeEventKey ? null : eventKey;

    if (alwaysOpen) {
      if (Array.isArray(activeEventKey)) {
        if (activeEventKey.includes(eventKey)) {
          eventKeyPassed = activeEventKey.filter(k => k !== eventKey);
        } else {
          eventKeyPassed = [...activeEventKey, eventKey];
        }
      } else {
        // activeEventKey is undefined.
        eventKeyPassed = [eventKey];
      }
    }

    onSelect == null ? void 0 : onSelect(eventKeyPassed, e);
    onClick == null ? void 0 : onClick(e);
  };
}
const AccordionButton = /*#__PURE__*/react.forwardRef(({
  // Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
  as: Component = 'button',
  bsPrefix,
  className,
  onClick,
  ...props
}, ref) => {
  bsPrefix = (0,ThemeProvider/* useBootstrapPrefix */.vE)(bsPrefix, 'accordion-button');
  const {
    eventKey
  } = (0,react.useContext)(AccordionItemContext);
  const accordionOnClick = useAccordionButton(eventKey, onClick);
  const {
    activeEventKey
  } = (0,react.useContext)(AccordionContext);

  if (Component === 'button') {
    props.type = 'button';
  }

  return /*#__PURE__*/(0,jsx_runtime.jsx)(Component, {
    ref: ref,
    onClick: accordionOnClick,
    ...props,
    "aria-expanded": eventKey === activeEventKey,
    className: classnames_default()(className, bsPrefix, !isAccordionItemSelected(activeEventKey, eventKey) && 'collapsed')
  });
});
AccordionButton.displayName = 'AccordionButton';
/* harmony default export */ var esm_AccordionButton = (AccordionButton);
;// CONCATENATED MODULE: ./node_modules/react-bootstrap/esm/AccordionHeader.js





const AccordionHeader = /*#__PURE__*/react.forwardRef(({
  // Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
  as: Component = 'h2',
  bsPrefix,
  className,
  children,
  onClick,
  ...props
}, ref) => {
  bsPrefix = (0,ThemeProvider/* useBootstrapPrefix */.vE)(bsPrefix, 'accordion-header');
  return /*#__PURE__*/(0,jsx_runtime.jsx)(Component, {
    ref: ref,
    ...props,
    className: classnames_default()(className, bsPrefix),
    children: /*#__PURE__*/(0,jsx_runtime.jsx)(esm_AccordionButton, {
      onClick: onClick,
      children: children
    })
  });
});
AccordionHeader.displayName = 'AccordionHeader';
/* harmony default export */ var esm_AccordionHeader = (AccordionHeader);
;// CONCATENATED MODULE: ./node_modules/react-bootstrap/esm/AccordionItem.js






const AccordionItem = /*#__PURE__*/react.forwardRef(({
  // Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
  as: Component = 'div',
  bsPrefix,
  className,
  eventKey,
  ...props
}, ref) => {
  bsPrefix = (0,ThemeProvider/* useBootstrapPrefix */.vE)(bsPrefix, 'accordion-item');
  const contextValue = (0,react.useMemo)(() => ({
    eventKey
  }), [eventKey]);
  return /*#__PURE__*/(0,jsx_runtime.jsx)(AccordionItemContext.Provider, {
    value: contextValue,
    children: /*#__PURE__*/(0,jsx_runtime.jsx)(Component, {
      ref: ref,
      ...props,
      className: classnames_default()(className, bsPrefix)
    })
  });
});
AccordionItem.displayName = 'AccordionItem';
/* harmony default export */ var esm_AccordionItem = (AccordionItem);
;// CONCATENATED MODULE: ./node_modules/react-bootstrap/esm/Accordion.js












const Accordion = /*#__PURE__*/react.forwardRef((props, ref) => {
  const {
    // Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
    as: Component = 'div',
    activeKey,
    bsPrefix,
    className,
    onSelect,
    flush,
    alwaysOpen,
    ...controlledProps
  } = (0,esm/* useUncontrolled */.Ch)(props, {
    activeKey: 'onSelect'
  });
  const prefix = (0,ThemeProvider/* useBootstrapPrefix */.vE)(bsPrefix, 'accordion');
  const contextValue = (0,react.useMemo)(() => ({
    activeEventKey: activeKey,
    onSelect,
    alwaysOpen
  }), [activeKey, onSelect, alwaysOpen]);
  return /*#__PURE__*/(0,jsx_runtime.jsx)(AccordionContext.Provider, {
    value: contextValue,
    children: /*#__PURE__*/(0,jsx_runtime.jsx)(Component, {
      ref: ref,
      ...controlledProps,
      className: classnames_default()(className, prefix, flush && `${prefix}-flush`)
    })
  });
});
Accordion.displayName = 'Accordion';
/* harmony default export */ var esm_Accordion = (Object.assign(Accordion, {
  Button: esm_AccordionButton,
  Collapse: esm_AccordionCollapse,
  Item: esm_AccordionItem,
  Header: esm_AccordionHeader,
  Body: esm_AccordionBody
}));

/***/ })

}]);